import { type PaymentBreakdown, BreakdownTypes } from '../../../types/PaymentBreakdown';
import { type OrderItem } from '../../../types/OrderItem';

/**
 * Checks for valid string amount presentation.
 * Should be positive, non-zero value with
 * maximum 2 digits after a period.
 * @param value String
 */
export function isValidAmount(value: string) {
  if (typeof value !== 'string') {
    return false;
  }
  if (value.endsWith('.') || isFalsy(value)) {
    return false;
  }

  const number = Number(value);
  if (isNaN(number) || number < 0) {
    return false;
  }
  return /^[0-9]+(\.[0-9][0-9]?)?$/.test(value);
}

export const isFalsy = (value: any): boolean => {
  return !value;
};

export const roundAmount = (value: string | number): number => {
  const number = Number(value);

  if (isNaN(number)) {
    return number;
  }

  return Math.round(number * 100) / 100;
};

export const getBreakdownTotal = (breakdown: PaymentBreakdown, orderItems: OrderItem[] = []): number => {
  const itemsTotal = getOrderItemsTotal(orderItems);
  return roundAmount(
    itemsTotal +
      (Number(breakdown[BreakdownTypes.Shipping]) || 0) +
      (Number(breakdown[BreakdownTypes.Tax]) || 0) -
      (Number(breakdown[BreakdownTypes.Discount]) || 0),
  );
};

export const getOrderItemsTotal = (orderItems: OrderItem[]): number => {
  return orderItems.reduce((acc, item) => {
    const itemSubtotal = roundAmount(Number(item.price) * item.quantity);
    acc += itemSubtotal;

    return roundAmount(acc);
  }, 0);
};

export const formatAmount = (amount: number): string => {
  return amount.toFixed(2);
};
